import NotificationSettings from "./notificationSettings.container";

export default NotificationSettings;
